import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';
import { ISectionRowProps as IProps } from 'components/BusinessToolForm';

import { concatWithDot } from 'helpers/string';

import { LIST_OF_FOUNDERS_FIELDS } from '../../utils/form';

export const FoundersRow: FC<IProps> = memo(({ name, disabled = false }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <BorderedCard>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <TextInputControl
            control={control}
            id={concatWithDot(name, LIST_OF_FOUNDERS_FIELDS.FIRST_NAME)}
            name={concatWithDot(name, LIST_OF_FOUNDERS_FIELDS.FIRST_NAME)}
            label={t('company.general.firstName')}
            disabled={disabled}
            maxLength={150}
          />
        </Grid>
        <Grid item xs={4}>
          <TextInputControl
            control={control}
            id={concatWithDot(name, LIST_OF_FOUNDERS_FIELDS.LAST_NAME)}
            name={concatWithDot(name, LIST_OF_FOUNDERS_FIELDS.LAST_NAME)}
            label={t('company.general.lastName')}
            disabled={disabled}
            maxLength={150}
          />
        </Grid>
        <Grid item xs={4}>
          <NumberInputControlled
            control={control}
            id={concatWithDot(name, LIST_OF_FOUNDERS_FIELDS.SHARE_IN_COMPANY)}
            name={concatWithDot(name, LIST_OF_FOUNDERS_FIELDS.SHARE_IN_COMPANY)}
            label={t('company.general.share')}
            adornmentType="percentage"
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </BorderedCard>
  );
});
